import React, { useState, useRef } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import LoadingSpinner from '../components/LoadingSpinner';
import { toast } from 'react-toastify';
import './Services.css';

const API_BASE = process.env.REACT_APP_FILE_API_URL;

const FileUpload = () => {
  const { user } = useAuth0();
  const isAdmin = localStorage.getItem('isAdmin') === 'true';
  const username = isAdmin ? 'admin' : (user?.nickname || user?.name || user?.email);
  const [fileId, setFileId] = useState('');
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [file, setFile] = useState(null);
  const fileInput = useRef();

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.error('Please select a file first');
      return;
    }
    setUploading(true);
    setError('');
    const formData = new FormData();
    formData.append('file', file);
    try {
      // Set userId explicitly to 'admin' if user logged in with admin credentials
      const userId = isAdmin ? 'admin' : username;
      const res = await fetch(`${API_BASE}/files/upload?userId=${userId}`,
        { 
          method: 'POST', 
          body: formData,
          headers: {
            'Authorization': 'Basic YWRtaW46YWRtaW4='
          }
        });
      const text = await res.text();
      const match = text.match(/ID: ([a-zA-Z0-9]+)/);
      setFileId(match ? match[1] : '');
      fileInput.current.value = '';
      setFile(null);
      e.target.reset();
      toast.success('File uploaded successfully!');
    } catch (error) {
      console.error('Upload error:', error);
      setError('Upload failed.');
      toast.error('Failed to upload file. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="service-page">
      <h1>Upload File</h1>
      <form className="file-upload-form" onSubmit={handleUpload}>
        <div className="file-input-container">
          <input
            type="file"
            ref={fileInput}
            onChange={handleFileChange}
            disabled={uploading}
            className="file-input"
          />
          {file && <span className="selected-file">Selected: {file.name}</span>}
        </div>
        <button type="submit" disabled={uploading || !file} className="upload-button">
          {uploading ? <LoadingSpinner /> : 'Upload'}
        </button>
      </form>
      {fileId && <div className="service-result">File uploaded with ID: <b>{fileId}</b></div>}
      {error && <div className="file-error">{error}</div>}
      {uploading && <div className="loading-overlay"><LoadingSpinner /></div>}
    </div>
  );
};

export default FileUpload;
